var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20999 13.5501C10.0601 13.5501 11.56 12.0503 11.56 10.2001C11.56 8.34994 10.0601 6.8501 8.20999 6.8501C6.35983 6.8501 4.85999 8.34994 4.85999 10.2001C4.85999 12.0503 6.35983 13.5501 8.20999 13.5501Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20999 20.0002C10.5075 20.0002 12.37 18.8227 12.37 17.3702C12.37 15.9177 10.5075 14.7402 8.20999 14.7402C5.91248 14.7402 4.04999 15.9177 4.04999 17.3702C4.04999 18.8227 5.91248 20.0002 8.20999 20.0002Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.51 5.64C15.0674 5.64 16.33 4.37744 16.33 2.82C16.33 1.26256 15.0674 0 13.51 0C11.9526 0 10.69 1.26256 10.69 2.82C10.69 4.37744 11.9526 5.64 13.51 5.64Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2.88 5.64C4.43744 5.64 5.7 4.37744 5.7 2.82C5.7 1.26256 4.43744 0 2.88 0C1.32255 0 0.0599976 1.26256 0.0599976 2.82C0.0599976 4.37744 1.32255 5.64 2.88 5.64Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.35 7.83008C13.03 7.83008 12.72 7.83008 12.41 7.88008C12.8807 8.6975 13.0934 9.63808 13.0203 10.5785C12.9471 11.5189 12.5915 12.4153 12 13.1501C12.448 13.2388 12.9033 13.2857 13.36 13.2901C15.9 13.2901 17.95 12.0601 17.95 10.5601C17.95 9.06008 15.89 7.83008 13.35 7.83008Z",
    fill: "#CC9C33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.472054c26011a07723228f8219d63e43.svg";
export { ForwardRef as ReactComponent };